import KdPrompt from './Prompt.vue'

interface Options {
  title: string
  confirmButtonText: string
  cancelButtonText: string
  placeholder: string
  wordLimit: number
  value: string
  rows?: number
  autoFocus?: boolean
  confirmButtonType?: string
  required?: boolean
}

export default class {
  private readonly options: Partial<Options>

  constructor(options?: Partial<Options>) {
    this.options = options || {}
  }

  show() {
    const instance = new KdPrompt({
      el: document.createElement('div'),
      data: this.options,
    })

    const result: Promise<string | null> = new Promise((resolve) => {
      instance.$on('cancel', () => resolve(null))
      instance.$on('confirm', (value: string) => resolve(value))
    })

    document.body.append(instance.$el)

    return result
  }

  static show(options?: Partial<Options>) {
    return new this(options).show()
  }
}
